import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import '@/styles/modal.scss';


interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  isLoading = false
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          className: 'modal-dialog'
        }
      }}
    >
      <Box className="modal-header">
        <DialogTitle className="modal-header-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          className="modal-close-button"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      
      <DialogContent className="modal-content-padded">
        <Box>
          <Typography className="modal-message-text">
            {message}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions className="modal-actions-flex" sx={{ pt: 1, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          fullWidth
          disabled={isLoading}
          className="modal-button-base modal-button-outlined"
        >
          {cancelText || t("cancel", "Cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          fullWidth
          disabled={isLoading}
          className="modal-button-base modal-button-primary"
        >
          {confirmText || t("confirm", "Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
